import firebase from '../Firebase/Firebase';

export const offerRef = (db, demandId, artisanId) => (
  db.collection('demands').doc(demandId).collection('offers').doc(artisanId)
);

export const offersRef = (db, demandId) => (
  db.collection('demands').doc(demandId).collection('offers')
);

export const offerStatusLabel = (status, t) => {
  const key = {
    pending: 'jobs.offers.pending',
    accepted: 'jobs.offers.accepted',
    declined: 'jobs.offers.declined',
    withdrawn: 'withdraw.confirm',
  }[status];
  return key && typeof t === 'function' ? t(key) : String(status || '');
};

export const normalizeOfferAsEstimation = (offer = {}) => ({
  offer_id: offer.offer_id || offer.artisan_id || '',
  demand_id: offer.demand_id || '',
  artisan_id: offer.artisan_id || '',
  artisan_firstname: offer.artisan_firstname || '',
  artisan_lastname: offer.artisan_lastname || '',
  artisan_email: offer.artisan_email || '',
  artisan_profile_image: offer.artisan_profile_image || '',
  estimation_description: offer.estimation_description || '',
  visit_date: offer.visit_date || '',
  artisan_phone_number: offer.artisan_phone_number || '',
  assessment_mode: offer.assessment_mode || 'visit_required',
  additional_info_request: offer.additional_info_request || '',
  estimation_post_date: offer.created_at || offer.updated_at || firebase.firestore.Timestamp.now(),
  estimation_material_cost: Number(offer.estimation_material_cost) || 0,
  estimation_wage: Number(offer.estimation_wage) || 0,
  estimated_budget: Number(offer.estimated_budget) || 0,
});

export const subscribeToDemandOffers = (db, demandId, onData, onError) => {
  if (!demandId) {
    onData?.([]);
    return () => undefined;
  }

  return offersRef(db, demandId).onSnapshot(
    (snapshot) => {
      const rows = snapshot.docs
        .map((doc) => ({ ...doc.data(), offer_id: doc.id }))
        .sort((a, b) => {
          const toMillis = (value) => value?.toMillis?.() || value?.seconds * 1000 || 0;
          return toMillis(b.updated_at || b.created_at) - toMillis(a.updated_at || a.created_at);
        });
      onData?.(rows);
    },
    onError,
  );
};

/**
 * Subscribe to the authenticated artisan's own nested offer documents.
 * Each offer contains a sanitized demand_snapshot, so declined artisans never
 * need permanent read access to the private parent demand.
 */
export const subscribeToArtisanOffers = (db, artisanId, onData, onError) => {
  if (!artisanId) {
    onData?.([]);
    return () => undefined;
  }

  return db
    .collectionGroup('offers')
    .where('artisan_id', '==', artisanId)
    .limit(300)
    .onSnapshot(
      (snapshot) => {
        const rows = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            offer_id: doc.id,
            demand_id: doc.data().demand_id || doc.ref.parent.parent?.id || '',
          }))
          .sort((a, b) => {
            const toMillis = (value) => value?.toMillis?.() || value?.seconds * 1000 || 0;
            return toMillis(b.updated_at || b.created_at) - toMillis(a.updated_at || a.created_at);
          });
        onData?.(rows);
      },
      onError,
    );
};
